import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import GenericBasicInfo from "../../../../components/cards/GenericBasicInfo";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../variables";
import PropTypes from "prop-types";
import _ from "lodash";
import { DateTime } from "luxon";
import { currencies } from "../../../../helpers";
import { activitiesTrueFalseMapping } from "../../common";
import { useQuery } from "@tanstack/react-query";
import { genericRequestErrorHandler } from "../../../../api";
import { retrieveActAPIConfiguration } from "../../../../api/ActivitiesEngine/APIConfigurations";
import Loader from "../../../../components/Loader";
import { CustomButton } from "../../../../components/CustomButton";
import ActivitiesEngineLogsTab from "./ActivitiesEngineLogsTab";
import TabStrip from "../../../../components/TabStrip";
import ReservationsStatusTag from "../../../../components/Tags/ReservationsStatusTag";

const enviromentOptions = {
  "": "-----",
  STAGING: "Staging",
  PRODUCTION: "Production",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DetailActivitiesAPIConfigurationModal: {
    ...modalGenericStyles.modal,
  },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: modalGenericStyles.cardHeader,
  modalCardBody: {
    ...modalGenericStyles.cardBody,
    display: "grid",
    gridGap: variables.normal_gap,
    gridTemplateRows: "repeat(2, max-content)",
  },
  modalCardActions: modalGenericStyles.cardActions,
  card: cardStyles.card,
  cardBody: cardStyles.body,
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: variables.normal_gap,
  },
  [`@media ${variables.media.smallscreen}`]: {
    row: {
      gridTemplateColumns: "2fr 1fr",
    },
  },
});

const DetailActivitiesAPIConfigurationModal = ({ uid, onClose }) => {
  const classes = styles();

  const [activeTab, setActiveTab] = useState("basicData");

  const menuTabs = {
    basicData: "Basic Data",
    logs: "Logs",
  };

  const { data: activities, isLoading } = useQuery({
    queryKey: ["ActivitiesAPIConfigurations", uid],
    queryFn: () => {
      return retrieveActAPIConfiguration({
        uid: uid,
      });
    },
    onError: (error) => genericRequestErrorHandler(error),
  });

  const apiCredentialsCpl = [
    ["Client Id", "client_id"],
    ["Client Secret", "client_secret"],
    ["Base Url", "base_url"],
    ["Grand Type", "grand_type"],
    ["X Musement Application", "x_musement_application"],
  ];

  const basicDataCpl = [
    ["Uid", "uid"],
    ["Name", "name"],
    ["Market Type", "market_type"],
    ["Source Entity", "source_entity"],
    ["Currency", null, _.get(currencies, _.get(activities, "data.currency"))],
    [
      "Is Global",
      null,
      _.get(activitiesTrueFalseMapping, _.get(activities, "data.is_global")),
    ],
    [
      "Is Own",
      null,
      _.get(activitiesTrueFalseMapping, _.get(activities, "data.is_own")),
    ],
    [
      "Is Master Account",
      null,
      _.get(
        activitiesTrueFalseMapping,
        _.get(activities, "data.is_master_account")
      ) || "N/A",
    ],
    ["Website Api Key", "website_api_key"],
    [
      "Environment",
      null,
      _.get(enviromentOptions, _.get(activities, "data.environment")),
    ],
    [
      "Status",
      null,
      <ReservationsStatusTag status={_.get(activities, "data.status")} />,
    ],
  ];
  const creatorData = [
    [
      "Created",
      null,
      DateTime.fromISO(_.get(activities, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];
  return (
    <div className={classes.DetailActivitiesAPIConfigurationModal}>
      <div className={classes.modalCard}>
        <div className={classes.modalCardHeader}>
          <span>Activities API Configuration Details</span>
        </div>
        <TabStrip
          tabs={Object.entries(menuTabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <div className={classes.modalCardBody}>
          {isLoading ? (
            <Loader />
          ) : (
            <React.Fragment>
              {activeTab === "basicData" && (
                <React.Fragment>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Basic Data"}
                        cardInfo={basicDataCpl}
                        objectData={_.get(activities, "data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Creator Data"}
                        cardInfo={creatorData}
                        objectData={_.get(activities, "data", {})}
                      />
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header="API Credentials"
                        cardInfo={apiCredentialsCpl}
                        objectData={_.get(activities, "data", {})}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {activeTab === "logs" && <ActivitiesEngineLogsTab />}
            </React.Fragment>
          )}
        </div>
        <div className={classes.modalCardActions}>
          <CustomButton appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DetailActivitiesAPIConfigurationModal.propTypes = {
  uid: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DetailActivitiesAPIConfigurationModal;
